import Checkbox from '@atlaskit/checkbox';
import VisuallyHidden from '@atlaskit/visually-hidden';
import React, { memo } from 'react';

import { type CheckboxReadContent } from './checkbox-read-content.ts';
import styles from './checkbox-value-view.module.css';

/**
 * Preserves V1 read-only geometry and value text; interaction remains host-owned.
 */
export const CheckboxValueView = memo(function CheckboxValueView({
  content,
  alignToContent = true
}: {
  readonly content: CheckboxReadContent;
  /**
   * Remove the control inset when aligning with adjacent text.
   */
  readonly alignToContent?: boolean;
}) {
  return (
    <div
      className={alignToContent ? styles.aligned : styles.value}
      data-databases-checkbox-value=""
    >
      <VisuallyHidden>{content.label}</VisuallyHidden>
      <Checkbox
        isChecked={content.checked}
        isDisabled
        testId="table-v2-checkbox-value"
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
});
